<template>
    <form action="#" @submit.prevent="saveContact">
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <input
                        type="text"
                        id="first_name"
                        name="first_name"
                        placeholder="First Name"
                        class="form-control shadow rounded-0"
                        :class="{ 'is-invalid': error.first_name }"
                        v-model="form.first_name"
                    />
                    <div class="invalid-feedback" v-if="error.first_name">
                        {{ error.first_name[0] }}
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <input
                        type="text"
                        id="last_name"
                        name="last_name"
                        placeholder="Last Name (Optional)"
                        class="form-control shadow rounded-0"
                        :class="{ 'is-invalid': error.last_name }"
                        v-model="form.last_name"
                    />
                    <div class="invalid-feedback" v-if="error.last_name">
                        {{ error.last_name[0] }}
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group">
            <input
                type="email"
                id="mail"
                name="mail"
                placeholder="Email Address"
                class="form-control shadow rounded-0"
                v-model="form.email"
                :class="{ 'is-invalid': error.email }"
            />
            <div class="invalid-feedback" v-if="error.email">
                {{ error.email[0] }}
            </div>
        </div>
        <div class="form-group">
            <input
                type="text"
                id="subject"
                name="subject"
                placeholder="subject"
                class="form-control shadow rounded-0"
                v-model="form.subject"
                :class="{ 'is-invalid': error.subject }"
            />
            <div class="invalid-feedback" v-if="error.subject">
                {{ error.subject[0] }}
            </div>
        </div>
        <div class="form-group">
            <textarea
                name="message"
                id="message"
                placeholder="Write your message"
                class="form-control shadow rounded-0"
                v-model="form.message"
                :class="{ 'is-invalid': error.message }"
            ></textarea>
            <div class="invalid-feedback" v-if="error.message">
                {{ error.message[0] }}
            </div>
        </div>
        <a-button
            type="primary"
            :loading="submitting"
            shape="round"
            size="large"
            htmlType="submit"
        >
            Send Message
        </a-button>
    </form>
</template>

<script>
import { HTTP } from "../api";
export default {
    props: ["user"],
    data() {
        return {
            form: {
                first_name: "",
                last_name: "",
                email: "",
                subject: "",
                message: "",
            },
            submitting: false,
            error: {},
        };
    },
    methods: {
        async saveContact() {
            this.submitting = true;
            this.error = {};
            try {
                await HTTP.post("contact-messages", { ...this.form });
                this.form = {
                    first_name: "",
                    last_name: "",
                    email: "",
                    subject: "",
                    message: "",
                };
                this.$notification.success({
                    message: "Thanks for your message.",
                    description: "We will reach out to you ASAP.",
                });
            } catch (error) {
                if (error?.response && error?.response?.status === 422) {
                    this.error = error.response.data.errors;
                } else if (error?.response && error?.response?.status === 429) {
                    this.$notification.error({
                        message: error?.response?.data?.message,
                    });
                } else {
                    this.$notification.error({
                        message: "Server error. Plz try again",
                    });
                }
            }
            this.submitting = false;
        },
    },
    created() {
        if (this.user && this.user !== "") {
            const user = JSON.parse(this.user);
            this.form.first_name = user.first_name;
            this.form.last_name = user.last_name;
            this.form.email = user.email;
        }
    },
};
</script>
